export default "__VITE_ASSET__VkHXY2WG__"